// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ssl-certificates-container {
  padding: 20px 0;
  width: 100%;
  max-width: none;
  margin: 0;
}
.ssl-certificates-container h1 {
  color: #2C7EA0;
  margin-bottom: 1rem;
  font-weight: 600;
}
.ssl-certificates-container .main-content-flex {
  display: flex;
  gap: 20px;
  margin-top: 20px;
  width: 100%;
  flex-wrap: nowrap;
  align-items: flex-start;
}
.ssl-certificates-container .sidebar {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 20px;
  position: relative;
  transition: all 0.3s ease;
}
.ssl-certificates-container .sidebar.left {
  width: 260px;
  min-width: 260px;
  max-height: 80vh;
  overflow-y: auto;
}
.ssl-certificates-container .sidebar.left.closed {
  width: 50px;
  min-width: 50px;
  padding: 10px;
}
.ssl-certificates-container .sidebar .toggle-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
  padding: 4px 8px;
  font-size: 12px;
}
.ssl-certificates-container .sidebar h4 {
  color: #2C7EA0;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  padding-right: 2rem;
}
.ssl-certificates-container .center-content {
  flex: 1;
  min-width: 0;
  width: 100%;
}
.ssl-certificates-container .center-content h4 {
  color: #2C7EA0;
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
}
.ssl-certificates-container .card {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  margin-bottom: 1.5rem;
}
.ssl-certificates-container .card .card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 1rem 1.25rem;
}
.ssl-certificates-container .card .card-header h5 {
  margin: 0;
  color: #495057;
  font-weight: 600;
  font-size: 1.1rem;
}
.ssl-certificates-container .form-label {
  font-weight: 500;
  color: #495057;
}
.ssl-certificates-container .form-label strong {
  color: #2C7EA0;
}
.ssl-certificates-container .ssl-active-check {
  padding-top: 2rem;
}
.ssl-certificates-container .field-picker {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1rem;
}
.ssl-certificates-container .summary-row {
  row-gap: 0.75rem;
}
.ssl-certificates-container .table {
  background-color: #fff;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  width: 100%;
}
.ssl-certificates-container .table th {
  color: #495057;
  font-weight: 600;
  white-space: nowrap;
}
.ssl-certificates-container .table td {
  vertical-align: middle;
}
@media (max-width: 768px) {
  .ssl-certificates-container .main-content-flex {
    flex-direction: column;
  }
  .ssl-certificates-container .sidebar.left,
  .ssl-certificates-container .sidebar.left.closed {
    width: 100%;
    min-width: auto;
    max-height: none;
  }
}`, "",{"version":3,"sources":["webpack://./frontend/sass/pages/ssl-certificates.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;AACF;AACE;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;AACJ;AAEE;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,uBAAA;AAAJ;AAGE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;AADJ;AAGI;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AADN;AAGM;EACE,WAAA;EACA,eAAA;EACA,aAAA;AADR;AAKI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AAHN;AAMI;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AAJN;AAQE;EACE,OAAA;EACA,YAAA;EACA,WAAA;AANJ;AAQI;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;AANN;AAUE;EACE,yBAAA;EACA,kBAAA;EACA,yCAAA;EACA,qBAAA;AARJ;AAUI;EACE,yBAAA;EACA,gCAAA;EACA,qBAAA;AARN;AAUM;EACE,SAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AARR;AAaE;EACE,gBAAA;EACA,cAAA;AAXJ;AAaI;EACE,cAAA;AAXN;AAeE;EACE,iBAAA;AAbJ;AAgBE;EACE,aAAA;EACA,eAAA;EACA,gBAAA;AAdJ;AAiBE;EACE,gBAAA;AAfJ;AAkBE;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yCAAA;EACA,WAAA;AAhBJ;AAkBI;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;AAhBN;AAmBI;EACE,sBAAA;AAjBN;AAqBE;EACE;IACE,sBAAA;EAnBJ;EAsBE;;IAEE,WAAA;IACA,eAAA;IACA,gBAAA;EApBJ;AACF","sourcesContent":[".ssl-certificates-container {\n  padding: 20px 0;\n  width: 100%;\n  max-width: none;\n  margin: 0;\n\n  h1 {\n    color: #2C7EA0;\n    margin-bottom: 1rem;\n    font-weight: 600;\n  }\n\n  .main-content-flex {\n    display: flex;\n    gap: 20px;\n    margin-top: 20px;\n    width: 100%;\n    flex-wrap: nowrap;\n    align-items: flex-start;\n  }\n\n  .sidebar {\n    background: #f8f9fa;\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    padding: 20px;\n    position: relative;\n    transition: all 0.3s ease;\n\n    &.left {\n      width: 260px;\n      min-width: 260px;\n      max-height: 80vh;\n      overflow-y: auto;\n\n      &.closed {\n        width: 50px;\n        min-width: 50px;\n        padding: 10px;\n      }\n    }\n\n    .toggle-btn {\n      position: absolute;\n      top: 10px;\n      right: 10px;\n      z-index: 10;\n      padding: 4px 8px;\n      font-size: 12px;\n    }\n\n    h4 {\n      color: #2C7EA0;\n      font-size: 1.1rem;\n      font-weight: 600;\n      margin-bottom: 1rem;\n      padding-right: 2rem;\n    }\n  }\n\n  .center-content {\n    flex: 1;\n    min-width: 0;\n    width: 100%;\n\n    h4 {\n      color: #2C7EA0;\n      font-size: 1.2rem;\n      font-weight: 600;\n      margin-bottom: 1.5rem;\n    }\n  }\n\n  .card {\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n    margin-bottom: 1.5rem;\n\n    .card-header {\n      background-color: #f8f9fa;\n      border-bottom: 1px solid #dee2e6;\n      padding: 1rem 1.25rem;\n\n      h5 {\n        margin: 0;\n        color: #495057;\n        font-weight: 600;\n        font-size: 1.1rem;\n      }\n    }\n  }\n\n  .form-label {\n    font-weight: 500;\n    color: #495057;\n\n    strong {\n      color: #2C7EA0;\n    }\n  }\n\n  .ssl-active-check {\n    padding-top: 2rem;\n  }\n\n  .field-picker {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem 1rem;\n  }\n\n  .summary-row {\n    row-gap: 0.75rem;\n  }\n\n  .table {\n    background-color: #fff;\n    border-radius: 6px;\n    overflow: hidden;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n    width: 100%;\n\n    th {\n      color: #495057;\n      font-weight: 600;\n      white-space: nowrap;\n    }\n\n    td {\n      vertical-align: middle;\n    }\n  }\n\n  @media (max-width: 768px) {\n    .main-content-flex {\n      flex-direction: column;\n    }\n\n    .sidebar.left,\n    .sidebar.left.closed {\n      width: 100%;\n      min-width: auto;\n      max-height: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
